import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';

import { Contact } from '../../../../shared/model';
import { SystemSelectService } from '../../system-select/system-select.service';
import { SourceContactService, SourceService } from '../../camtl.service';


import { CgpGridComponent } from '../../../../shared/cgp-grid/cgp-grid.component';
import { CgpSnackbarService } from '../../../../shared/cgp-snackbar/cgp-snackbar.service';
import { CgpConfirmationDialogService } from '../../../../shared/cgp-confirmation-dialog/cgp-confirmation-dialog.service';
import { CgpAlertDialogService } from '../../../../shared/cgp-alert-dialog/cgp-alert-dialog.service';

@Component({
  selector: 'app-camtl-source-contacts',
  templateUrl: './camtl-source-contacts.component.html',
  // styleUrls: ['./camtl-source-contacts.component.scss']
})
export class CamtlSourceContactsComponent implements OnInit {

  constructor(
    public formBuilder: FormBuilder,
    public systemSelectService: SystemSelectService,
    public sourceContactService: SourceContactService,
    public sourceService: SourceService,
    public cgpSnackbarService: CgpSnackbarService,
    public cgpConfirmationDialogService: CgpConfirmationDialogService,
    public cgpAlertDialogService: CgpAlertDialogService
  ) { }

  @ViewChild(CgpGridComponent, { static: true }) grid: CgpGridComponent;

  gridFilter: boolean;
  editForm: FormGroup;
  isNew: boolean = false;
  editDataItem: Contact;
  system: any;
  systemId: any;
  sourceId: any;

  ngOnInit() {
    this.systemSelectService.system$
      .subscribe(system => {
        this.system = system;
        if (this.system) {
          this.systemId = this.system.Id;
        }
        else {
          this.systemId = undefined;
        }
        this.refresh();
      });

    this.systemSelectService.get();

    this.editForm = this.formBuilder.group({
      SystemId: [""],
      SourceId: ["", Validators.required],
      SourceContactId: [""]
    })
  }

  refresh() {
    this.gridFilter = !this.gridFilter;
  }

  onRead = (force: boolean, dataItem: any, state: any) => {
    return this.systemId ?
      this.sourceContactService.read("/" + this.systemId, true) :
      Promise.resolve([]);
  }

  onEdit = (object) => {
    this.sourceService.read("?$filter=SourceTypeId eq " + object.dataItem.SourceTypeId + " and IsActive eq true", true)
      .then((response) => {
        delete response.Count;
        delete response.NextPageLink;
      });
  }

  onSave = (dataItem) => {
    dataItem.SystemId = this.systemId;

    if (dataItem.SourceContactId !== null) {
      dataItem.Id = dataItem.SourceContactId;
    }

    this.sourceContactService.save(dataItem, true, "", false)
      .then(() => {
        this.grid.refresh(true);
        this.cgpSnackbarService.showSnackbar({
          message: "Contact has been assigned",
          duration: 2000
        })
      })
  }

  onDelete = (dataItem) => {
    if (dataItem.Required) {
      this.cgpAlertDialogService.showAlertDialog({
        title: 'Error',
        message: 'A contact is mandatory for this field. Please edit contact if change is required.',
        alert: 'danger',
        closeLabel: 'Close',
      })
    }
    else if (dataItem.SourceName == "" || dataItem.SourceName == " " || dataItem.SourceName == null) {
      this.cgpAlertDialogService.showAlertDialog({
        title: 'Error',
        message: 'Cannot delete an empty contact field.',
        alert: 'danger',
        closeLabel: 'Close',
      })
    }
    else {
      this.sourceContactService.remove("/" + dataItem.SourceId + "/" + this.systemId).then(() => {
        this.grid.refresh(true);
        this.cgpSnackbarService.showSnackbar({
          message: "Contact has been deleted",
          duration: 2000
        })
      })
    }
  }

  columns: any[] =
    [
      {
        field: "SourceTypeName",
        title: "Source Type",
        checkRequired: true
      },
      {
        field: "SourceName",
        title: "Source Name"
      }
    ]

  template = {
    controls: {
      add: false,
      edit: true,
      delete: true,
      excel: true
    },
    columns: this.columns,
    service: this.sourceContactService,
    fileName: "sourceContacts.xlsx",
    save: this.onSave,
    delete: this.onDelete,
    read: this.onRead
  };

  formDialog = {
    title: "Contact",
    formControls: [
      {
        type: 'combobox',
        name: 'SourceId',
        title: 'Source Name',
        textField: 'SourceName',
        valueField: 'Id',
        placeholder: 'Select Source...',
        service: this.sourceService,
        sync: true
      }
    ]
  }
}
